const propagateRouterEvents = (retries) => {
  if (window.Backbone?.Router) {
    window.Backbone.Router.prototype.on('route', () => {
      window.dispatchEvent(new Event('route'))
    })

    window.Backbone.Router.prototype.trigger('route')
  } else if (retries > 0) {
    setTimeout(() => propagateRouterEvents(--retries), 400)
  }
}

const propagatePurpleWaveEvents = (retries => {
  if (window.PurpleWave) {
    window.PurpleWave.vent.on('login', () => {
      window.dispatchEvent(new Event('login'))
    })
    window.PurpleWave.vent.on('logout', () => {
      window.dispatchEvent(new Event('logout'))
    })
  } else if (retries > 0) {
    setTimeout(() => propagatePurpleWaveEvents(--retries), 400)
  }
})

propagateRouterEvents(16)
propagatePurpleWaveEvents(16)